import { render } from "./creditor-index.vue?vue&type=template&id=aa858dd4&scoped=true"
import script from "./creditor-index.vue?vue&type=script&lang=js"
export * from "./creditor-index.vue?vue&type=script&lang=js"

import "./creditor-index.vue?vue&type=style&index=0&id=aa858dd4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa858dd4"]])

export default __exports__